import * as React from "react";
import "./styles.scss";
var Modal = function (props) {
    var handleClose = function () {
        if (props.onClose) {
            props.onClose();
        }
    };
    var handleSubmit = function () {
        if (props.onSubmit) {
            props.onSubmit();
        }
    };
    return (React.createElement("div", { className: "modal ".concat(props.active ? 'in' : ''), role: "dialog" },
        React.createElement("div", { className: "modal-dialog modal-open-zoom\", ".concat(props.large ? 'modal-lg' : props.small ? 'modal-sm' : props.xLarge ? 'modal-x-lg' : ''), role: "document" },
            React.createElement("div", { className: "modal-content" },
                props.title &&
                    React.createElement("div", { className: "modal-header", style: { background: "".concat(props.titleBarBgColor ? props.titleBarBgColor : "white"),
                            color: "".concat(props.titleFontColor ? props.titleFontColor : "#f5821f"),
                            borderBottom: "none", } },
                        React.createElement("h4", { className: "modal-title" }, props.title),
                        props.cancellable &&
                            React.createElement("button", { type: "button", className: "close", "data-dismiss": "modal", "aria-label": "Close", onClick: handleClose },
                                React.createElement("span", { "aria-hidden": "true" }, "\u00D7"))),
                React.createElement("div", { className: "modal-body", style: props.bodyStyle }, props.children),
                (props.onSubmit || props.cancellable) && !props.disableFooter &&
                    React.createElement("div", { className: "modal-footer", style: { borderTop: "none" } },
                        props.cancellable &&
                            React.createElement("button", { type: "button", className: "btn btn-default", "data-dismiss": "modal", onClick: handleClose }, props.cancelTitle || "Close"),
                        props.onSubmit &&
                            React.createElement("button", { type: "button", className: "btn btn-primary", disabled: props.disableSubmit, onClick: handleSubmit }, props.submitTitle || "Submit"))))));
};
export default Modal;
//# sourceMappingURL=index.js.map